import { render, staticRenderFns } from "./MalCinsiPicker.vue?vue&type=template&id=3164f1e7"
import script from "./MalCinsiPicker.vue?vue&type=script&lang=ts"
export * from "./MalCinsiPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports